import React, { useState, useEffect } from "react";
import { Configurations } from "../../../Utils/Configurations";
import './Cile-Content.scss';
import axios from "axios";
import ContentCileList from "../../../Components/Content-Cile-List/Content-Cile-List";
import { withRouter } from "react-router-dom";
import Pagination from "rc-pagination";
import qs from 'qs';

const CileContentReview = (props) => {

    const [resenhas, setResenhas] = useState([])
    const [loading, setLoading] = useState(true)
    const [paginacao, setPaginacao] = useState({})


    useEffect(() => {
        chamadaResenha()
    }, [])

    useEffect(() => {
        chamadaResenha()
    }, [window.location.search])


    const chamadaResenha = () => {
        const config = new Configurations();

        const values = qs.parse(window.location.search)
        const pagina = parseInt(values["?pagina"], 10)

        setLoading(true)
        axios.get(config.apiBasePath + `/conteudo-cile/resenhas?limite=10&pagina=${pagina}`)
            .then(response => {
                setResenhas(response.data)
                setPaginacao({
                    ...response.data.paginacao,
                })
            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() => {
                setLoading(false)
            });
    }

    const onChangePage = (page) => {
        setPaginacao({
            ...paginacao,
            paginaAtual: page
        })
        props.history.push(`resenhas?pagina=${page}&limite=10`)
    }


    return (
        <div className="cile-remessas">
            <div className="row">
                <div className="col-12 py-2">
                    <div className="row no-gutters align-items-center">
                        <div className="col-12 col-lg-4 text-center text-lg-left">
                            <h2 className="title-1 d-none d-lg-block">CILE - Resenhas</h2>
                        </div>
                        <div className="col-6 col-lg-4 text-center text-lg-center">
                            <button className="btn btn-outline-primary" type="button" onClick={() => props.history.push('resenhas/nova-resenha')}>
                                incluir resenha
                            </button>
                        </div>
                        <div className="col-6 col-lg-4 text-center text-lg-right">
                            <div className="row no-gutters">
                                <div className="col py-2 py-lg-0">
                                    <button onClick={() => window.history.go(-1)} className="btn btn-outline-secondary">voltar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card">
                <div className="row no-gutters align-items-center py-lg-4 px-lg-3">

                    {loading ?
                        <div className="d-flex justify-content-center w-100">
                            <div className="spinner-border text-primary" role="status" />
                        </div>
                        :
                        <>
                            <ContentCileList
                                conteudo={resenhas}
                            />

                            <div className="col-12 d-flex justify-content-center pt-3">
                                <Pagination onChange={onChangePage} current={paginacao.paginaAtual} total={paginacao.totalPaginas * paginacao.limite} pageSize={paginacao.limite} />
                            </div>
                        </>
                    }

                </div>
            </div>
        </div>
    )
}


export default withRouter(CileContentReview);